import {KodataStoresQueryFilters} from '@/map/enums';
import {convertToMyfcCategoryFromKodata} from '@/map/utils';
import {Flexbox, FlexFullGrow} from '@/styled-components';
import {
  FilterOptionButton, FilterOptionButtonGroup, OptionLabel, OptionName
} from '../StyledComponents';

interface IProps {
  categories: string[];
  initialValues: string[];
  onChange(key: KodataStoresQueryFilters, value: any): void;
}

export const CategoryFilter = ({
  categories,
  initialValues,
  onChange,
}: IProps) => {
  return (
    <div>
      <Flexbox>
        <OptionName>업종</OptionName>
        <FlexFullGrow />
        <OptionLabel>다중 선택</OptionLabel>
      </Flexbox>
      <FilterOptionButtonGroup>
        {categories.map((i) => (
          <FilterOptionButton
            key={i}
            active={initialValues?.findIndex((x) => x === i) >= 0}
            onClick={() => onChange(KodataStoresQueryFilters.categories, i)}
          >
            {convertToMyfcCategoryFromKodata(i)}
          </FilterOptionButton>
        ))}
      </FilterOptionButtonGroup>
    </div>
  );
};
